import React, { useState, } from 'react';
import { Image, } from '@waglabs/image-next';
import LazyLoad from 'react-lazyload';
import { LazyWrapper, } from './LazyWrapper';
import { Placeholder } from './Placeholder';
export const LazyImage = ({ alt, aspectRatio = '1:1', height, imageProps, offset = 100, once = true, placeholder = React.createElement(Placeholder, null), src, srcSet, ...others }) => {
    const [loaded, setLoaded] = useState(false);
    const handleImageLoad = () => setLoaded(true);
    const [aspectRatioX, aspectRatioY] = aspectRatio.split(':');
    const pb = `${(+aspectRatioY / +aspectRatioX) * 100}%`;
    return (React.createElement(LazyWrapper, Object.assign({ pb: height || pb }, others),
        React.createElement(LazyLoad, { offset: offset, once: once },
            !loaded && placeholder,
            React.createElement(Image, Object.assign({ alt: alt, height: "100%", left: 0, position: "absolute", srcSet: srcSet, src: src, style: {
                    objectFit: 'cover',
                }, top: 0, width: "100%", onLoad: handleImageLoad }, imageProps)))));
};
